import { Action } from '@ngrx/store';

import { HierarchyNodesResults } from '®shared/hierarchy';

export enum NodeSearchActionTypes {
  NODE_SEARCH_CLEARED = '[Node search] search term cleared',
  NODE_SEARCH_FAILED = '[Node search] search failed',
  NODE_SEARCH_INITIATED = '[Node search] search initiated',
  NODE_SEARCH_RESULTS_LOADED = '[Node search] search results loaded',
}

export class NodeSearchClearedAction implements Action {
  readonly type = NodeSearchActionTypes.NODE_SEARCH_CLEARED;
}

export interface NodeSearchPayload {
  searchTerm: string;
  limit: number;
}

export class NodeSearchInitiatedAction implements Action {
  readonly type = NodeSearchActionTypes.NODE_SEARCH_INITIATED;

  constructor(public payload: NodeSearchPayload) {}
}

export interface NodeSearchResultsLoadedPayload extends NodeSearchPayload {
  results: HierarchyNodesResults;
}

export class NodeSearchResultsLoadedAction implements Action {
  readonly type = NodeSearchActionTypes.NODE_SEARCH_RESULTS_LOADED;

  constructor(public payload: NodeSearchResultsLoadedPayload) {}
}

export interface NodeSearchFailedPayload extends NodeSearchPayload {
  error: any;
}

export class NodeSearchFailedAction implements Action {
  readonly type = NodeSearchActionTypes.NODE_SEARCH_FAILED;

  constructor(public payload: NodeSearchFailedPayload) {}
}

export type NodeSearchActions =
  | NodeSearchClearedAction
  | NodeSearchFailedAction
  | NodeSearchInitiatedAction
  | NodeSearchResultsLoadedAction;
